// import useAuthentication from "@hooks/useAuthentication";
import EmrContainerV2 from "../layouts/emrcontainer/EmrContainerV2";
import EmrContainerV1 from "../layouts/emrcontainer/emrContainerV1";




const GrantsForDental = () => {
    // const { user } = useAuthentication();

    // const isDentalDoctor =
    //     user?.region?.trim().toUpperCase() === "QATAR_REGION" && user.groupName === "Dental";
    const isDentalDoctor = false

    return (
        <div>
            {isDentalDoctor ? <EmrContainerV2 /> : <EmrContainerV1 />}
        </div>
    );
};

export default GrantsForDental;